/** TanStack Query keys for the workspace screens (always under `["ws", wsId]` for invalidation). */
export const wsKeys = {
  dashboard: (wsId: string, range: string, agentId: string | null) => ["ws", wsId, "dashboard", range, agentId] as const,
  checklist: (wsId: string) => ["ws", wsId, "setup-checklist"] as const,
  /** Own key: `["ws", id, "agents"]` holds the full AgentListOut for the build group. */
  agents: (wsId: string) => ["ws", wsId, "workspace-screens", "agents"] as const,
  customDomains: (wsId: string) => ["ws", wsId, "custom-domains"] as const,
  billing: (wsId: string) => ["ws", wsId, "billing"] as const,
  billingOverview: (wsId: string) => ["ws", wsId, "billing", "overview"] as const,
  salesRequests: (wsId: string) => ["ws", wsId, "billing", "sales-requests"] as const,
  billingPlans: (wsId: string) => ["ws", wsId, "billing", "plans"] as const,
  addonCatalog: (wsId: string) => ["ws", wsId, "billing", "addons"] as const,
  billingConfig: (wsId: string) => ["ws", wsId, "billing", "config"] as const,
  billingRegion: (wsId: string) => ["ws", wsId, "billing", "region"] as const,
  billingDetails: (wsId: string) => ["ws", wsId, "billing", "details"] as const,
  invoices: (wsId: string, q: string) => ["ws", wsId, "billing", "invoices", q] as const,
  usageBreakdown: (wsId: string, by: string) => ["ws", wsId, "billing", "usage", by] as const,
  planPreview: (wsId: string, plan: string, interval: string) => ["ws", wsId, "billing", "preview", plan, interval] as const,
  organization: (wsId: string) => ["ws", wsId, "settings", "organization"] as const,
  security: (wsId: string) => ["ws", wsId, "settings", "security"] as const,
  privacy: (wsId: string) => ["ws", wsId, "settings", "privacy"] as const,
  apiKeys: (wsId: string) => ["ws", wsId, "settings", "api-keys"] as const,
  webhooks: (wsId: string) => ["ws", wsId, "settings", "webhooks"] as const,
  deliveries: (wsId: string, webhookId: string) => ["ws", wsId, "settings", "webhooks", webhookId, "deliveries"] as const,
  integrations: (wsId: string) => ["ws", wsId, "settings", "integrations"] as const,
  audit: (wsId: string, filters: string) => ["ws", wsId, "settings", "audit", filters] as const,
  notificationPrefs: (wsId: string) => ["ws", wsId, "settings", "notification-preferences"] as const,
  dataExports: (wsId: string) => ["ws", wsId, "settings", "data-exports"] as const,
  sessions: ["me", "sessions"] as const,
} as const;
